import { useTranslation } from "react-i18next";
import { LeafModal } from "../../../leaf/LeafModal/LeafModal";
import defaultContent from "../../../../content/keyMetrics";
import "./KpiInfoModal.scss";

type Props = {
  open: boolean;
  onClose: () => void;
  kpi: string;
};

export const KpiInfoModal = ({ open, onClose, kpi }: Props) => {
  const { t } = useTranslation(["keyMetrics"]);

  const modalTitle = t(`${kpi}ModalTitle`, defaultContent[`${kpi}ModalTitle`] || "");
  const modalDescription = t(`${kpi}ModalDescription`, defaultContent[`${kpi}ModalDescription`] || "");

  return (
    <LeafModal open={open} onCloseCallbackFn={onClose} title={modalTitle} id={`${kpi}-info-modal`}>
      <div className="KpiInfoModal">
        <p className="KpiInfoModal__description">{modalDescription}</p>
      </div>
    </LeafModal>
  );
};
